"use client";
import React, { Suspense } from "react";
import PageLayout from "@/layouts/pageLayout";
import HeroComponent from "./components/hero";
import CloudCardsTabs from "./components/services";
import FaqComponent from "./components/faqs";
import IntroComponent from "./components/intro";

const CloudServicesPage = () => {
  return (
    <PageLayout showContactForm showFeatures spacing={20}>
      <HeroComponent />
      <IntroComponent />
      <Suspense>
        <CloudCardsTabs />
      </Suspense>
      <FaqComponent />
    </PageLayout>
  );
};

export default CloudServicesPage;
